import type { ReactElement } from 'react'

import { cn } from '@/lib/cn'

export type Origem = 'hubspot' | 'metas' | 'contaazul' | 'clickup' | 'sympla' | 'pendente'

const CONFIG: Record<Origem, { nome: string; cor: string }> = {
  hubspot: { nome: 'HubSpot', cor: 'bg-warning' },
  metas: { nome: 'Metas', cor: 'bg-primary' },
  contaazul: { nome: 'Conta Azul', cor: 'bg-muted-foreground' },
  clickup: { nome: 'ClickUp', cor: 'bg-info' },
  sympla: { nome: 'Sympla', cor: 'bg-success' },
  // Indicador previsto cuja fonte ainda não existe — o selo deixa explícito que
  // a ausência é de origem do dado, não falha de carregamento.
  pendente: { nome: 'Sem fonte', cor: 'bg-destructive' },
}

/**
 * Selo visível da origem do dado — responde "de onde veio esse número?" sem
 * precisar abrir a explicação. O campo exato (ex.: `deal.amount`) vai no `title`.
 */
export function Fonte({ origem, campo }: { origem: Origem; campo?: string }): ReactElement {
  const { nome, cor } = CONFIG[origem]
  return (
    <span
      title={campo ? `${nome} · ${campo}` : `Fonte: ${nome}`}
      className="border-border text-muted-foreground inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-medium"
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', cor)} aria-hidden />
      {nome}
    </span>
  )
}
